var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAuthenticated
    ? _c(
        "div",
        { staticClass: "d-flex flex-column flex-root" },
        [
          _vm.loaderEnabled
            ? _c("Loader", { attrs: { logo: _vm.loaderLogo } })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex flex-row flex-column-fluid page" },
            [
              _vm.asideEnabled ? _c("KTAside") : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column flex-row-fluid wrapper",
                  attrs: { id: "kt_wrapper" },
                },
                [
                  _c("KTHeader", {
                    attrs: {
                      title: _vm.pageTitle,
                      overlayShow: _vm.overlayShow,
                    },
                  }),
                  _vm.subheaderDisplay
                    ? _c("KTSubheader", {
                        attrs: {
                          breadcrumbs: _vm.breadcrumbs,
                          title: _vm.pageTitle,
                        },
                      })
                    : _vm._e(),
                  _vm.isSettingsPage ? _c("SettingsSubheader") : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "content d-flex flex-column flex-column-fluid",
                      class: _vm.isSettingsPage ? "subheader-included" : "",
                      attrs: { id: "kt_content" },
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-column-fluid" }, [
                        _c(
                          "div",
                          { staticClass: "container-fluid" },
                          [
                            _c("BBAlert"),
                            _c(
                              "transition",
                              [
                                _c("router-view", {
                                  on: { "toggle-overlay": _vm.toggleOverlay },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.toolbarDisplay ? _c("KTStickyToolbar") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }